import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7f312bbedae700143c7ce2_1787380749875_1ca447c7/invoice_1786720555348/src/app/hub/page.tsx");
